import {Injectable} from "@angular/core";

@Injectable()
export class SidenavService {

    private sidenav: any;
    constructor() {
    }

    public toggle() {
        this.sidenav.toggle();
    }

    public setSidenav(sidenav: any) {
        this.sidenav = sidenav;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/sidenav.service.ts